import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface LoadingStyleState {
  progressStyles: Record<string, React.CSSProperties>
  loadingMap: Record<string, boolean>
}

const initialState: LoadingStyleState = {
  progressStyles: {},
  loadingMap: {
    fetchUptimeMetrics: true,
    fetchOrderStatusMetrics: true,
    fetchPreventiveActions: true,
    fetchCases: true,
    fetchPacketLoss: true,
    fetchLatencyMetrics: true,
    fetchTrafficNodes: true,
    fetchSites: true,
    fetchEventsData: true,
    fetchCurrentBill: true,
    fetchBillingCards: true,
    fetchCaseMetrics: true,
    fetchNetworkServices: true,
    fetchsitesNodeStatus: true,
    fetchActiveServices: true,
    fetchBillingBasic: true,
  },
}

const loadingStyleSlice = createSlice({
  name: 'loadingStyle',
  initialState,
  reducers: {
    setProgressStyles: (
      state,
      action: PayloadAction<{
        key: string
        value: React.CSSProperties
      }>,
    ) => {
      state.progressStyles[action.payload.key] = action.payload.value
    },
    setLoadingMap: (
      state,
      action: PayloadAction<{
        key: string
        value: boolean
      }>,
    ) => {
      state.loadingMap[action.payload.key] = action.payload.value
    },
  },
})

export const { setProgressStyles, setLoadingMap } = loadingStyleSlice.actions
export default loadingStyleSlice.reducer
